// extracted by mini-css-extract-plugin
module.exports = {"itemDragHandle":"GVItemsCustomOrder_itemDragHandle__oBaF2","itemDragged":"GVItemsCustomOrder_itemDragged__IZ0ow","hidden":"GVItemsCustomOrder_hidden__5vcAV"};